import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["clsPrefix", "fontName", "type", "className"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src";
var propTypes = {
  type: PropTypes.string
};
/**
 *  badge 默认显示内容1
 */

var defaultProps = {
  fontName: 'uf',
  type: '',
  className: ''
};
var Icon = (_dec = WebUI({
  name: "icon",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Icon, _Component);

  var _super = _createSuper(Icon);

  function Icon(props) {
    _classCallCheck(this, Icon);

    return _super.call(this, props);
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          clsPrefix = _this$props.clsPrefix,
          fontName = _this$props.fontName,
          type = _this$props.type,
          className = _this$props.className,
          others = _objectWithoutProperties(_this$props, _excluded);

      var classNames = classnames(clsPrefix, fontName, type, className);
      return /*#__PURE__*/React.createElement("i", _extends({}, others, {
        className: classNames
      }));
    }
  }]);

  return Icon;
}(Component)) || _class);
Icon.propTypes = propTypes;
export default Icon;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-icon/src/Icon.js